/* eslint-disable */
<template>
  <div class="container-fluid no-padding">
    <div class="row">
      <div class="col mb-2 mt-2 align-middle">
        <label for="hat-search">Arama</label>
        <input id="hat-search" type="text" @keyup.enter="getHatlar" class="form-control" v-model="searchFilter" placeholder="Numara ve ya ICCID yazın ve Enter'a basın" />
      </div>
      <div class="col mb-2 mt-2 align-middle">
        <label for="note-search">Not Filtresi</label>
        <input id="note-search" type="text" @keyup.enter="getHatlar" class="form-control" v-model="noteFilter" placeholder="Not yazın ve Enter'a basın" />
      </div>
      <div class="col mb-2 mt-2 align-middle">
        <label for="type-select">Hat Durumu</label>
        <select v-model="statusType" @change="getHatlar" class="form-control float-left" id="type-select">
          <option value="-1" selected>Tüm Hatlar</option>
          <option value="0">Boştakiler</option>
          <option value="1">Kullanımdakiler</option>
          <option value="3">Dondurulmuş Sözleşmelerdekiler</option>
          <option value="2">Fesh Sözleşmelerdekiler</option>
          <option value="4">Hat listesinde olmayıp bir cihaza eşlenmiş olanlar</option>
        </select>
      </div>
      <div class="col mb-2 mt-2 align-middle">
        <label for="operator-select">Operatör</label>
        <select v-model="operatorType" @change="getHatlar" class="form-control float-left" id="operator-select">
          <option value="TÜMÜ" selected>Tüm Operatörler</option>
          <option value="TÜRK TELEKOM">TÜRK TELEKOM</option>
          <option value="TURKCELL">TURKCELL</option>
        </select>
      </div>
      <div class="col mb-2 mt-2" v-if="isActionEnabled">
        <label for="operations">İşlemler</label>
        <div class="btn-group float-right ml-2">
          <button class="btn btn-outline-primary dropdown-toggle"
            type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Toplu İşlemler
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <h6 class="dropdown-header">Toplu İşlemler</h6>
            <a role="button" class="dropdown-item" @click="openModal('hatBatchUpdateModal')">
              <i class="fas fa-external-link-alt text-secondary"></i>&nbsp;&nbsp;Güncelle</a>
            <a role="button" class="dropdown-item" @click="openModal('hatBatchUnassignModal')">
              <i class="fas fa-external-link-alt text-secondary"></i>&nbsp;&nbsp;Boşa Çıkarma</a>
            <a role="button" class="dropdown-item text-danger"
              data-toggle="modal" @click="openModal('hatBatchDeleteModal')" aria-expanded="false">
              <i class="fas fa-trash-alt text-danger"></i>&nbsp;&nbsp;&nbsp;Hat Silme</a>
            <h6 class="dropdown-header">Dışa Aktarma</h6>
            <a role="button" class="dropdown-item" @click="getHatlarForExport()">
              <i class="fas fa-file-excel text-secondary"></i>&nbsp;&nbsp;Excel'e Aktar</a>
            <h6 class="dropdown-header">Kritik İşlemler</h6>
            <a role="button" class="dropdown-item" @click="openModal('hatBatchImportModal')">
              <i class="fas fa-file-import text-secondary"></i>&nbsp;&nbsp;Hat Yükleme</a>
          </div>
        </div>
        <button id="operations" class="btn btn-primary float-right" @click="openModal('hatInsertModal')">Yeni Hat Ekle</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-wait for="hatlar-loading">
          <template slot="waiting">
            <div class="vue-wait-class">
              <img src="static/loading.svg" />
              <p>Hatlar yükleniyor...</p>
            </div>
          </template>
          <div class="row align-items-center">
            <div class="col-3 justify-content-start">
              <span class="badge badge-primary mr-4 mb-2">
                Filtreyle eşleşen <strong class="text-white">{{ hatlarCount }}</strong> hat bulundu.
              </span>
            </div>
            <div class="col-6 justify-content-start d-flex flex-row justify-content-start align-items-center">
              <span class="mr-3 mb-2">Sayfa: {{ activePage }} / {{ pageCount }}</span>
              <button class="btn btn-outline-primary btn-sm mr-1" @click="setPage(1)" :disabled="activePage == 1">İlk Sayfa</button>
              <button class="btn btn-outline-primary btn-sm mr-1" @click="setPage(activePage - 1)" :disabled="activePage == 1">Önceki Sayfa</button>
              <button class="btn btn-outline-primary btn-sm mr-1" @click="setPage(activePage + 1)" :disabled="activePage == pageCount">Sonraki Sayfa</button>
              <button class="btn btn-outline-primary btn-sm" @click="setPage(pageCount)" :disabled="activePage == pageCount">Son Sayfa</button>
            </div>
            <div class="col-3 justify-content-start d-flex flex-row align-items-center">
              <select v-model="recordsPerPage" @change="getHatlar" class="form-control float-left" id="pageSize-select">
                <option value=25>Sayfa Başına 25 hat</option>
                <option value=50>Sayfa Başına 50 hat</option>
                <option value=100>Sayfa Başına 100 hat</option>
              </select>
            </div>
          </div>
          <table class="table table-bordered caption-top">
            <thead class="thead-light">
              <tr>
                <th v-if="isActionEnabled" style="width: 6.5%;" scope="col">
                  SEÇ
                </th>
                <th style="width: 10%;" scope="col">DURUM</th>
                <th style="width: 10%;" scope="col">OPERATÖR</th>
                <th style="width: 10%;" scope="col">GSM NO / ICCID</th>
                <th style="width: 20%;" scope="col">KULLANIM YERİ</th>
                <th v-if="statusType === '4'" style="width: 20%;" scope="col">SÖZLEŞME BİLGİSİ</th>
                <th v-if="statusType !== '4'" style="width: 25%;" scope="col">NOT</th>
                <th style="width: 15%;" scope="col">KOMUTLAR</th>
              </tr>
            </thead>
            <tbody class="tbody-margin">
              <template v-for="(hat, index) in hatlar">
                <tr :key="'trow-first-' + hat.HAT_GSMNO">
                  <td v-if="isActionEnabled" class="align-middle text-center">
                    <button class="btn btn-sm" :class="[checkHatSelection(hat.HAT_GSMNO) ? 'btn-outline-danger' : 'btn-outline-success']" @click="addHatToSelection(hat.HAT_GSMNO)">
                      <i class="mr-1 fas" :class="[checkHatSelection(hat.HAT_GSMNO) ? 'fa-times text-danger' : 'fa-check text-success']"></i>
                      {{ checkHatSelection(hat.HAT_GSMNO) ? 'Kaldır' : 'Seç' }}
                    </button>
                  </td>
                  <td class="align-middle text-center">
                    <div class="justify-content-between">
                      <span class="btn-more-radius badge" :class="parseHatStatusAsClass(hat)">{{parseHatStatusAsText(hat)}}</span>
                      <small v-if="hat.DATE_DELETED" class="text-muted">{{hat.DATE_DELETED}}</small>
                    </div>
                  </td>
                  <td class="align-middle text-center">
                    {{ statusType !== '4' ? hat.HAT_OPERATOR : parseHatOperator(hat.HAT_GSMNO) }}
                  </td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0 font-semi-bold tabular-nums">{{hat.HAT_GSMNO}}</p>
                      <small v-if="statusType !== '4'" class="text-muted tabular-nums">{{hat.HAT_SERINO || 'ICCID TANIMSIZ'}}</small>
                    </div>
                  </td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0">{{hat.CUSTOMER_TITLE}}</p>
                      <small class="text-muted">{{hat.VEHICLE_NAME}}</small>
                      <small class="text-muted">&bull;</small>
                      <small class="text-muted tabular-nums">{{hat.IMEI_NO}}</small>
                      <template v-if="statusType !== 0 && parseHatStatusAsText(hat) !== 'BOŞTA'">
                        <small class="text-muted">&bull;</small>
                        <small class="text-muted tabular-nums">{{hat.SERVER_TIME}}</small>
                      </template>
                    </div>
                  </td>
                  <td v-if="statusType === '4'" class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0">{{hat.CONTRACT_NAME}}</p>
                      <small class="text-muted">{{parseContractStatus(hat.CONTRACT_STATUS)}}</small>
                      <small class="text-muted">&bull;</small>
                      <small class="text-muted">{{hat.CONTRACT_DATE}}</small>
                    </div>
                  </td>
                  <td v-if="statusType !== '4'" class="align-middle"><div class="text-truncate">{{hat.HAT_NOTLAR}}</div></td>
                  <td class="align-middle text-center">
                    <template v-if="isActionEnabled">
                      <button v-if="statusType !== '4'" class="btn btn-success" @click="selectHat(index); openModal('hatUpdateModal')">
                        <i class="fas fa-edit mr-1"></i>
                        Güncelle
                      </button>
                      <button class="btn btn-primary" @click="selectHat(index); openModal('hatUnassignModal')">
                        <i class="fas fa-times mr-1"></i>
                        Boşa Çıkar
                      </button>
                      <button v-if="statusType !== '4'" class="btn btn-danger" @click="selectHat(index); openModal('hatDeleteModal')">
                        <i class="fas fa-trash mr-1"></i>
                        Sil
                      </button>
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-wait>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatInsertModal" tabindex="-1"
      role="dialog" aria-labelledby="hatInsertModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatInsertModalLabel">Yeni Hat Ekleme</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="hat-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hatlar Ekleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-warning" role="alert">
                      Hat numaraları başında 0 olmadan 10 hane olarak yazılmalıdır. Örnek: 5321234567<br />
                      Her hat numarası yeni satır ile ayrılmalıdır.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="multipleInsertModel.UpdateExisting" id="flexCheckDefault">
                      <label class="form-check-label" for="flexCheckDefault">
                        Önceden kayıtlı olan hatları güncelle. (Operatör ve notlar güncellenecektir.)
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-operator-select">Operatör</label>
                    <select v-model="multipleInsertModel.Operator" class="form-control float-left" id="mi-operator-select">
                      <option value="Seçiniz..." selected>Operatör Seçiniz...</option>
                      <option value="TÜRK TELEKOM">TÜRK TELEKOM</option>
                      <option value="TURKCELL">TURKCELL</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-hatlar">HATLAR</label>
                    <textarea class="form-control" v-model="multipleInsertModel.Hatlar" id="mi-hatlar" rows="10"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-notes">NOTLAR</label>
                    <textarea class="form-control" v-model="multipleInsertModel.Notes" id="mi-notes" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="multipleInsertHat()" class="btn btn-success">Hatları Kaydet</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatUpdateModal" tabindex="-1"
      role="dialog" aria-labelledby="hatUpdateModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatUpdateModalLabel">Hat Güncelle</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="hat-updating">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hatlar Güncelleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-operator-select">Operatör</label>
                    <select v-model="newHat.HAT_OPERATOR" class="form-control float-left" id="mi-operator-select">
                      <option value="Seçiniz..." selected>Operatör Seçiniz...</option>
                      <option value="TÜRK TELEKOM">TÜRK TELEKOM</option>
                      <option value="TURKCELL">TURKCELL</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-hatlar">HATLAR</label>
                    <input disabled type="text" class="form-control" v-model="newHat.HAT_GSMNO" id="mi-hatlar">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-notes">NOTLAR</label>
                    <textarea class="form-control" v-model="newHat.HAT_NOTLAR" id="mi-notes" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="updateHat()" class="btn btn-success">Hattı Güncelle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatBatchUpdateModal" tabindex="-1"
      role="dialog" aria-labelledby="hatBatchUpdateModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatBatchUpdateModalLabel">Toplu Hat Güncelle</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="hat-updating">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hatlar Güncelleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-warning" role="alert">
                      Hat numaraları başında 0 olmadan 10 hane olarak yazılmalıdır. Örnek: 5321234567<br />
                      Her hat numarası yeni satır ile ayrılmalıdır.
                    </div>
                    <div class="alert alert-danger" role="alert">
                      Güncelleme işlemi sonrasında var olan notlar silinir, bu forma yazdığınız notlar eklenir.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="multipleInsertModel.UpdateExisting" id="flexCheckDefault">
                      <label class="form-check-label" for="flexCheckDefault">
                        Operatör bilgisini de güncelle. (Notların yanında operatör bilgisi de güncellenir.)
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="multipleInsertModel.UpdateExisting">
                  <div class="col-12 mb-3">
                    <label for="mi-operator-select">Operatör</label>
                    <select v-model="multipleInsertModel.Operator" class="form-control float-left" id="mi-operator-select">
                      <option value="Seçiniz..." selected>Operatör Seçiniz...</option>
                      <option value="TÜRK TELEKOM">TÜRK TELEKOM</option>
                      <option value="TURKCELL">TURKCELL</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-hatlar">HATLAR</label>
                    <textarea class="form-control" v-model="multipleInsertModel.Hatlar" id="mi-hatlar" rows="10"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-notes">NOTLAR</label>
                    <textarea class="form-control" v-model="multipleInsertModel.Notes" id="mi-notes" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="multipleUpdateHat()" class="btn btn-success">Hatları Güncelle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatBatchDeleteModal" tabindex="-1"
      role="dialog" aria-labelledby="hatBatchDeleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatBatchDeleteModalLabel">Toplu Hat Silme</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="hat-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hatlar Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="alert alert-danger" role="alert">
                      Belirlediğiniz hatları silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
                      <br /><br />
                      Hat - cihaz eşleşmesi de kaldırılacaktır.
                    </div>
                    <div class="alert alert-warning" role="alert">
                      Hat numaraları başında 0 olmadan 10 hane olarak yazılmalıdır. Örnek: 5321234567<br />
                      Her hat numarası yeni satır ile ayrılmalıdır.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-hatlar">HATLAR</label>
                    <textarea class="form-control" v-model="multipleInsertModel.Hatlar" id="mi-hatlar" rows="15"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="multipleDeleteHat()" class="btn btn-success">Hatları Sil</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatBatchUnassignModal" tabindex="-1"
      role="dialog" aria-labelledby="hatBatchUnassignModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatBatchUnassignModalLabel">Toplu Hat Boşa Çıkarma</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="hat-unassigning">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hatlar Boşa Çıkartılıyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="alert alert-danger" role="alert">
                      Belirlediğiniz hatları boşa çıkarmak istediğinizden emin misiniz? Bu işlem geri alınamaz.
                    </div>
                    <div class="alert alert-warning" role="alert">
                      Hat numaraları başında 0 olmadan 10 hane olarak yazılmalıdır. Örnek: 5321234567<br />
                      Her hat numarası yeni satır ile ayrılmalıdır.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-hatlar">HATLAR</label>
                    <textarea class="form-control" v-model="multipleInsertModel.Hatlar" id="mi-hatlar" rows="15"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="multipleUnassignHat()" class="btn btn-success">Hatları Boşa Çıkar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatDeleteModal" tabindex="-1"
      role="dialog" aria-labelledby="hatDeleteModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatDeleteModalLabel">Hat Silme</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="hat-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hat Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="alert alert-danger" role="alert">
                      Seçili hattı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
                      <template v-if="newHat.CUSTOMER_TITLE">
                      <br /><br />
                      Hat - cihaz eşleşmesi de kaldırılacaktır.
                      </template>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 mb-3">
                    <label for="hatGsmNo">HAT NUMARASI</label>
                    <input type="text" disabled class="form-control" :value="newHat.HAT_GSMNO" id="hatGsmNo">
                  </div>
                  <div class="col-6 mb-3">
                    <label for="hatOperator">OPERATÖR</label>
                    <input type="text" disabled class="form-control" :value="newHat.HAT_OPERATOR" id="hatOperator">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="hatSerino">ICCID</label>
                    <input type="text" disabled class="form-control" :value="newHat.HAT_SERINO || 'TANIMSIZ'" id="hatSerino">
                  </div>
                </div>
                <div class="row" v-if="newHat.CUSTOMER_TITLE">
                  <div class="col-4 mb-3">
                    <label for="hatCustomer">MÜŞTERİ</label>
                    <input type="text" disabled class="form-control" :value="newHat.CUSTOMER_TITLE || 'TANIMSIZ'" id="hatCustomer">
                  </div>
                  <div class="col-4 mb-3">
                    <label for="hatCustomer">ARAÇ</label>
                    <input type="text" disabled class="form-control" :value="newHat.VEHICLE_NAME || 'TANIMSIZ'" id="hatCustomer">
                  </div>
                  <div class="col-4 mb-3">
                    <label for="hatCustomer">CİHAZ SERİ NO</label>
                    <input type="text" disabled class="form-control" :value="newHat.DEVICE_ID || 'TANIMSIZ'" id="hatCustomer">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="hatNotes">NOTLAR</label>
                    <textarea disabled class="form-control" :value="newHat.HAT_NOTLAR" id="hatNotes" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteHat()" class="btn btn-danger">Hattı Sil</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatUnassignModal" tabindex="-1"
      role="dialog" aria-labelledby="hatUnassignModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatUnassignModalLabel">Hat Boşa Çıkarma</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="hat-unassigning">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hat Boşa Çıkarılıyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="alert alert-warning" role="alert">
                      Seçili hattı boşa çıkarmak istediğinizden emin misiniz? Bu işlem geri alınamaz.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 mb-3">
                    <label for="hatGsmNo">HAT NUMARASI</label>
                    <input type="text" disabled class="form-control" :value="newHat.HAT_GSMNO" id="hatGsmNo">
                  </div>
                  <div class="col-6 mb-3">
                    <label for="hatOperator">OPERATÖR</label>
                    <input type="text" disabled class="form-control" :value="newHat.HAT_OPERATOR" id="hatOperator">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="hatSerino">ICCID</label>
                    <input type="text" disabled class="form-control" :value="newHat.HAT_SERINO || 'TANIMSIZ'" id="hatSerino">
                  </div>
                </div>
                <div class="row" v-if="newHat.CUSTOMER_TITLE">
                  <div class="col-4 mb-3">
                    <label for="hatCustomer">MÜŞTERİ</label>
                    <input type="text" disabled class="form-control" :value="newHat.CUSTOMER_TITLE || 'TANIMSIZ'" id="hatCustomer">
                  </div>
                  <div class="col-4 mb-3">
                    <label for="hatCustomer">ARAÇ</label>
                    <input type="text" disabled class="form-control" :value="newHat.VEHICLE_NAME || 'TANIMSIZ'" id="hatCustomer">
                  </div>
                  <div class="col-4 mb-3">
                    <label for="hatCustomer">CİHAZ SERİ NO</label>
                    <input type="text" disabled class="form-control" :value="newHat.DEVICE_ID || 'TANIMSIZ'" id="hatCustomer">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="hatNotes">NOTLAR</label>
                    <textarea disabled class="form-control" :value="newHat.HAT_NOTLAR" id="hatNotes" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="unassignHat()" class="btn btn-warning">Hattı Boşa Çıkar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatBatchImportModal" tabindex="-1"
      data-backdrop="static" data-keyboard="false"
      role="dialog" aria-labelledby="hatBatchImportModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatBatchImportModalLabel">Toplu Hat Yükleme</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="hat-importing">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Hatlar yükleniyor...</p>
                </div>
              </template>
              <div class="container-fluid" v-if="batchImportModel.status == 0">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-success font-semi-bold" role="alert">
                      Yükleme işlemi öncesinde var olan hat listesi ve cihaz eşleşmelerinin bir kopyası alınacaktır. Bu sayede yükleme sonrası hatalar oluşursa, eski kayıtlar geri yüklenebilir.
                      
                      <button class="btn btn-success mt-3" @click="downloadSampleExcel()">Örnek Yükleme Dosyası İndir</button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="batchImportModel.deleteAndUnassignNonExistentRecords" id="bi-check-1">
                      <label class="form-check-label" for="bi-check-1">
                        Yüklenen listede olmayan hatları sil ve cihaz eşleşmelerini kaldır.
                      </label>
                      <small>
                        Seçtiğiniz dosyada olmayan hatlar, sistemde kayıtlı ise silinecek ve varsa cihaz eşleşmeleri kaldırılacaktır.
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="batchImportModel.keepNotesForExistingRecords" id="bi-check-2">
                      <label class="form-check-label" for="bi-check-2">
                        Var olan notları koru, yeni not ekleme.
                      </label>
                      <small>
                        Seçtiğiniz dosyada var olan hatlar, sistemde kayıtlı ise notları korunacak ve yeni not eklenmeyecektir.
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="form-check">
                      <input disabled class="form-check-input" type="checkbox" v-model="batchImportModel.takeSnapshotBeforeMerge" id="bi-check-3">
                      <label class="form-check-label" for="bi-check-3">
                        Yükleme öncesi kayıtların ve eşleşmelerin bir kopyasını oluştur.
                      </label>
                      <small>
                        Toplu yükleme işlemi yapılmadan önce var olan hat kayıtları ve cihaz eşleşmelerinin bir kopyası alınacaktır. Bu sayede yükleme sonrası hatalar oluşursa, eski kayıtlar geri yüklenebilir.
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="mi-file-select">Yükleme Dosyası</label>
                    <input type="file" class="form-control-file" accept=".xlsx, .xls" @change="batchImportModel.file = $event.target.files[0]" id="mi-file-select">
                  </div>
                </div>
              </div>
              <div class="container-fluid" v-else-if="batchImportModel.status == 1">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-success" role="alert">
                      <b>{{ batchImportModel.stagingCount }}</b> adet hattın toplu yükleme işlemi başarıyla tamamlandı.
                    </div>
                  </div>
                </div>
                <div class="row mb-2" v-for="(section, sectionIndex) in sections" :key="'section-' + sectionIndex">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="font-semi-bold">{{ section.title }}</h5>
                        <p v-for="stat in statLabels" :key="stat.key">
                          {{ stat.label }}: <b>{{ section[stat.key] }}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--
                <div class="row mb-2">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="font-semi-bold">İşlem Raporu</h5>
                        <p>İşlem öncesi toplam hat sayısı: <b>{{batchImportModel.totalRecords}}</b></p>
                        <p>İşlem sonrası toplam hat sayısı: <b>{{batchImportModel.newRecords + batchImportModel.updatedRecords}}</b></p>
                        <p>Yeni eklenen hat sayısı: <b>{{batchImportModel.newRecords}}</b></p>
                        <p>Güncellenen hat sayısı: <b>{{batchImportModel.updatedRecords}}</b></p>
                        <p>Silinen ve cihaz eşleşmesi kaldırılan hat sayısı: <b>{{batchImportModel.deletedRecords}}</b></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="font-semi-bold">Turkcell Raporu</h5>
                        <p>İşlem öncesi toplam hat sayısı: <b>{{batchImportModel.turkcellTotalRecords}}</b></p>
                        <p>İşlem sonrası toplam hat sayısı: <b>{{batchImportModel.turkcellNewRecords + batchImportModel.turkcellUpdatedRecords}}</b></p>
                        <p>Yeni eklenen hat sayısı: <b>{{batchImportModel.turkcellNewRecords}}</b></p>
                        <p>Güncellenen hat sayısı: <b>{{batchImportModel.turkcellUpdatedRecords}}</b></p>
                        <p>Silinen ve cihaz eşleşmesi kaldırılan hat sayısı: <b>{{batchImportModel.turkcellDeletedRecords}}</b></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="font-semi-bold">Türk Telekom Raporu</h5>
                        <p>İşlem öncesi toplam hat sayısı: <b>{{batchImportModel.turkTelekomTotalRecords}}</b></p>
                        <p>İşlem sonrası toplam hat sayısı: <b>{{batchImportModel.turkTelekomNewRecords + batchImportModel.turkTelekomUpdatedRecords}}</b></p>
                        <p>Yeni eklenen hat sayısı: <b>{{batchImportModel.turkTelekomNewRecords}}</b></p>
                        <p>Güncellenen hat sayısı: <b>{{batchImportModel.turkTelekomUpdatedRecords}}</b></p>
                        <p>Silinen ve cihaz eşleşmesi kaldırılan hat sayısı: <b>{{batchImportModel.turkTelekomDeletedRecords}}</b></p>
                      </div>
                    </div>
                  </div>
                </div>
                -->
              </div>
              <div class="container-fluid" v-else-if="batchImportModel.status == 2">
                <div class="row">
                  <div class="col-12">
                    <div class="alert alert-danger" role="alert">
                      <h4>Bir hata meydana geldi</h4>
                      <p>{{ batchImportModel.error }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button v-if="batchImportModel.status !== 3" type="button" class="btn btn-secondary" @click="dismissBatchImportModal(0)">Kapat</button>
            <button v-if="batchImportModel.status == 0" type="button" @click="batchImport()" class="btn btn-success">Toplu Yüklemeyi Başlat</button>
            <button v-else-if="batchImportModel.status == 1" type="button" @click="downloadResults()" class="btn btn-success">Detaylı İşlem Raporunu İndir</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="hatBatchImportReportConfirmationModal" tabindex="-1"
      data-backdrop="static" data-keyboard="false"
      role="dialog" aria-labelledby="hatBatchImportModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="hatBatchImportModalLabel">Toplu İşlem Raporu</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="alert alert-danger font-semi-bold" role="alert">
                  <p>Detaylı işlem raporunu indirmediniz. İndirmeden bu pencereyi kapatmak istiyor musunuz?</p>
                  <p>Endişe etmeyin, bu rapora daha sonra veritabanından ulaşılabilir. Ancak bunu yazılım ekibinizden talep etmeniz gerekecektir.</p>
                  <p>O yüzden şimdi fırsatınız varken indirin, sonra raporum da raporum diye ortalıkta dolaşmayın...</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="dismissBatchImportModal(1)">İndirmeden Kapat</button>
            <button type="button" @click="downloadResults()" class="btn btn-success">Detaylı İşlem Raporunu İndir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
import moment from 'moment'
import * as XLSX from 'xlsx'
import { summarizeMerge, STAT_LABELS } from '@/utils/mergeSummary';

export default {
  name: 'HatlarPage',
  data () {
    return {
      selectedHat: null,
      newHat: {
        HAT_GSMNO: '',
        HAT_SERINO: '',
        HAT_OPERATOR: 'TÜRK TELEKOM',
        HAT_NOTLAR: ''
      },
      multipleInsertModel: {
        Operator: 'Seçiniz...',
        Hatlar: '',
        Notes: '',
        UpdateExisting: true,
      },
      batchImportModel: {
        deleteAndUnassignNonExistentRecords: false,
        keepNotesForExistingRecords: false,
        takeSnapshotBeforeMerge: true,
        file: null,
        status: 0,
      },
      hatlar: [],
      hatlarForExport: [],
      hatlarCount: 0,
      statusType: -1,
      operatorType: 'TÜMÜ',
      searchFilter: '',
      noteFilter: '',
      activePage: 1,
      recordsPerPage: 100,
      pageCount: 0,
      hatCacheExpiry: 1000 * 60 * 60 * 4
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    isActionEnabled: function() { return this.getPersonelId == 3 || this.getPersonelId == 24 },
    sections() {
      const total = Object.assign({ title: 'TOPLAM VERİLER' }, this.batchImportModel.summary.total);
      const operators = this.batchImportModel.summary.operators.map(o => Object.assign({ title: o.operator }, o));
      return [total].concat(operators);
    },
    statLabels() {
      return STAT_LABELS;
    },
  },
  methods: {
    async getHatlarFromCache() {
      let hatlarLastRead = localStorage.getItem('hatlar-lastread')
      if((moment().valueOf() - parseInt(hatlarLastRead) >= this.hatCacheExpiry)) {
        this.getHatlar()
        return
      } else this.$wait.end('hatlar-loading')

      this.hatlar = JSON.parse(localStorage.getItem('hatlar-cache'))
      if(!this.hatlar) this.getHatlar()
      else this.$wait.end('hatlar-loading')
    },
    async getHatlar() {
      this.hatlar = [];

      this.$wait.start('hatlar-loading')
      axios.post('/api/hatlar/search',
        { 
          'SearchFilter': this.searchFilter,
          'NoteFilter': this.noteFilter,
          'Operator': this.operatorType, 
          'QueryType': parseInt(this.statusType),
          'Page': this.activePage,
          'PageSize': parseInt(this.recordsPerPage)
        }
      )
      .then(response => {
        this.hatlar = response.data
        this.hatlarCount = this.hatlar.length > 0 ? this.hatlar[0].TOTAL_COUNT : 0
        this.pageCount = Math.ceil(this.hatlarCount / this.recordsPerPage)
        console.log('pageCount: ' + this.pageCount)
        this.$wait.end('hatlar-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('hatlar-loading')
      })
    },
    async getHatlarForExport() {
      this.hatlarForExport = [];

      axios.post('/api/hatlar/export',
        { 
          'SearchFilter': this.searchFilter,
          'NoteFilter': this.noteFilter,
          'Operator': this.operatorType, 
          'QueryType': parseInt(this.statusType)
        }
      )
      .then(response => {
        this.hatlarForExport = response.data
        this.exportHatlar()
      })
      .catch(error => { 
        console.error(error) 
      })
    },
    async deleteHat() {
      this.$wait.start('hat-deleting')

      axios.delete('/api/hatlar/' + this.selectedHat.HAT_GSMNO)
      .then(response => {
        this.getHatlar()
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        $('#hatDeleteModal').modal('hide')
        this.$wait.end('hat-deleting')
        this.selectHat(-1)
      })
    },
    async updateHat() {
      if(this.newHat.HAT_OPERATOR == 'Seçiniz...') {
        alert('Lütfen bir operatör seçiniz.')
        return
      }
      
      this.$wait.start('hat-updating')
      
      axios.put('/api/hatlar/' + this.selectedHat.HAT_GSMNO, {
        'Operator': this.newHat.HAT_OPERATOR,
        'Notes': this.newHat.HAT_NOTLAR
      })
      .then(response => {
        this.getHatlar()
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        $('#hatUpdateModal').modal('hide')
        this.$wait.end('hat-updating')
        this.selectHat(-1);
      })
    },
    async unassignHat() {
      this.$wait.start('hat-unassigning')

      axios.post('/api/hatlar/' + this.selectedHat.HAT_GSMNO + '/unassign')
      .then(response => {
        this.getHatlar()
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        $('#hatUnassignModal').modal('hide')
        this.$wait.end('hat-unassigning')
        this.selectHat(-1);
      })
    },
    async multipleInsertHat() {
      if(this.multipleInsertModel.Operator == 'Seçiniz...') {
        alert('Lütfen bir operatör seçiniz.')
        return
      }

      if(this.multipleInsertModel.Hatlar.trim() == '') {
        alert('Lütfen en az bir hat numarası giriniz.')
        return
      }

      this.$wait.start('hat-inserting')

      axios.post('/api/hatlar/batch-insert', this.multipleInsertModel)
      .then(response => {
        this.getHatlar()
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        $('#hatInsertModal').modal('hide')
        this.$wait.end('hat-inserting')
        this.multipleInsertModel = {
          Operator: 'Seçiniz...',
          Hatlar: '',
          Notes: '',
          UpdateExisting: true,
        }
      })
    },
    async multipleUpdateHat() {
      if(this.multipleInsertModel.Operator == 'Seçiniz...') {
        alert('Lütfen bir operatör seçiniz.')
        return
      }

      if(this.multipleInsertModel.Hatlar.trim() == '') {
        alert('Lütfen en az bir hat numarası giriniz.')
        return
      }

      this.$wait.start('hat-updating')

      axios.post('/api/hatlar/batch-update', this.multipleInsertModel)
      .then(response => {
        this.getHatlar()
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        $('#hatBatchUpdateModal').modal('hide')
        this.$wait.end('hat-updating')
        this.multipleInsertModel = {
          Operator: 'Seçiniz...',
          Hatlar: '',
          Notes: '',
          UpdateExisting: true,
        }
      })
    },
    async multipleDeleteHat() {
      if(this.multipleInsertModel.Hatlar.trim() == '') {
        alert('Lütfen en az bir hat numarası giriniz.')
        return
      }

      this.$wait.start('hat-deleting')

      axios.post('/api/hatlar/batch-delete', this.multipleInsertModel)
      .then(response => {
        this.getHatlar()
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        $('#hatBatchDeleteModal').modal('hide')
        this.$wait.end('hat-deleting')
        this.multipleInsertModel = {
          Operator: 'Seçiniz...',
          Hatlar: '',
          Notes: '',
          UpdateExisting: true,
        }
      })
    },
    async multipleUnassignHat() {
      if(this.multipleInsertModel.Hatlar.trim() == '') {
        alert('Lütfen en az bir hat numarası giriniz.')
        return
      }

      this.$wait.start('hat-unassigning')

      axios.post('/api/hatlar/batch-unassign', this.multipleInsertModel)
      .then(response => {
        this.getHatlar()
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        $('#hatBatchUnassignModal').modal('hide')
        this.$wait.end('hat-unassigning')
        this.multipleInsertModel = {
          Operator: 'Seçiniz...',
          Hatlar: '',
          Notes: '',
          UpdateExisting: true,
        }
      })
    },
    async batchImport() {
      if(!this.batchImportModel.file) {
        alert('Lütfen bir dosya seçiniz.')
        return
      }

      this.$wait.start('hat-importing')
      this.batchImportModel.status = 3; // processing

      let formData = new FormData()
      formData.append('file', this.batchImportModel.file)
      formData.append('deleteAndUnassignNonExistentRecords', this.batchImportModel.deleteAndUnassignNonExistentRecords)
      formData.append('keepNotesForExistingRecords', this.batchImportModel.keepNotesForExistingRecords)
      formData.append('takeSnapshotBeforeMerge', this.batchImportModel.takeSnapshotBeforeMerge)

      axios.post('/api/hatlar/merge', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        this.getHatlar()        
        this.batchImportModel.summary = summarizeMerge(response.data)
        this.batchImportModel.stagingCount = response.data.length > 0 ? response.data[0].StagingCount : 0
        this.batchImportModel.status = 1
        this.batchImportModel.results = response.data
      })
      .catch(error => {
        console.error(error)
        this.batchImportModel.status = 2
        this.batchImportModel.error = error.response ? error.response.data : error.message
      })
      .finally(() => {
        this.$wait.end('hat-importing')
        this.batchImportModel.deleteAndUnassignNonExistentRecords = false
        this.batchImportModel.keepNotesForExistingRecords = false
        this.batchImportModel.takeSnapshotBeforeMerge = true
        this.batchImportModel.file = null
      })
    },
    downloadResults() {
      const excelData = this.batchImportModel.results.map(item => ({
        'OPERATÖR': item.MERGE_ACTION == 'SİLİNDİ' ? item.OLD_OPERATOR : item.NEW_OPERATOR,
        'HAT NUMARASI': item.GSMNO,
        'YAPILAN İŞLEM': item.MERGE_ACTION,
        'ESKI ICCID': item.OLD_SERINO,
        'YENİ ICCID': item.NEW_SERINO,
        'ESKİ NOT': item.OLD_NOTLAR,
        'YENİ NOT': item.NEW_NOTLAR,
        'MÜŞTERİ KODU': item.CUSTOMER_ID,
        'MÜŞTERİ ADI': item.CUSTOMER_TITLE,
        'ARAÇ KAYIT NO': item.VEHICLE_ID,
        'ARAÇ ADI': item.VEHICLE_NAME,
        'CİHAZ SERİ NO': item.IMEI_NO,
        'SÖZLEŞME DURUMU': item.CONTRACT_STATUS,
        'SÖZLEŞME ADI': item.CONTRACT_NAME,
        'SÖZLEŞME TARİHİ': item.CONTRACT_DATE
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Hat Yükleme Raporu');
      XLSX.writeFile(workbook, 'hatlar_toplu_yukleme_raporu.xlsx');

      this.dismissBatchImportModal(1);
    },
    downloadSampleExcel() {
      const sampleData = [
        { 'OPERATÖR': 'TÜRK TELEKOM', 'GSMNO': '5051234567', 'ICCID': '899', 'NOT': 'Örnek not' },
        { 'OPERATÖR': 'TURKCELL', 'GSMNO': '5321234567', 'ICCID': '899', 'NOT': 'Örnek not' },
        { 'OPERATÖR': 'VODAFONE', 'GSMNO': '5412345678', 'ICCID': '899', 'NOT': 'Örnek not' }
      ];

      const worksheet = XLSX.utils.json_to_sheet(sampleData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Hat Yükleme Örneği');
      XLSX.writeFile(workbook, 'hatlar_toplu_yukleme_ornegi.xlsx');
    },
    exportHatlar() {
      const excelData = this.hatlarForExport.map(item => ({
        'OPERATÖR': item.HAT_OPERATOR,
        'HAT NUMARASI': item.HAT_GSMNO,
        'ICCID': item.HAT_SERINO,
        'NOT': item.HAT_NOTLAR,
        'MÜŞTERİ KODU': item.CUSTOMER_ID,
        'MÜŞTERİ ADI': item.CUSTOMER_TITLE,
        'ARAÇ KAYIT NO': item.VEHICLE_ID,
        'ARAÇ ADI': item.VEHICLE_NAME,
        'CİHAZ SERİ NO': item.IMEI_NO,
        'SÖZLEŞME DURUMU': item.CONTRACT_STATUS,
        'SÖZLEŞME ADI': item.CONTRACT_NAME,
        'SÖZLEŞME TARİHİ': item.CONTRACT_DATE
      }));

      const exportFileName = 'hatlar listesi ' + moment(new Date()).format('DD.MM.YYYY HH:mm') + '.xlsx'

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'HATLAR');
      XLSX.writeFile(workbook, exportFileName);

      this.hatlarForExport = [];
    },
    addHatToSelection(hatGsmNo) {
      if(!this.checkHatSelection(hatGsmNo))
        this.multipleInsertModel.Hatlar += hatGsmNo + '\n'
      else
        this.removeHatFromSelection(hatGsmNo)
    },
    removeHatFromSelection(hatGsmNo) {
      this.multipleInsertModel.Hatlar = this.multipleInsertModel.Hatlar.replace(hatGsmNo + '\n', '')
    },
    checkHatSelection(hatGsmNo) {
      return this.multipleInsertModel.Hatlar.indexOf(hatGsmNo) !== -1
    },
    selectHat(index) {
      if(index == -1) {
        this.selectedHat = null
        this.newHat = {
          HAT_GSMNO: '',
          HAT_SERINO: '',
          HAT_OPERATOR: 'TÜRK TELEKOM',
          HAT_NOTLAR: ''
        }
        return
      }

      this.selectedHat = this.hatlar[index]
      this.newHat = this.selectedHat
    },
    parseHatStatusAsClass(hat) {
      if(hat.DATE_DELETED)
        return 'badge-secondary'
      
      if(hat.DEVICE_ID == null)
        return 'badge-success'
      else
        return 'badge-danger'
    },
    parseHatStatusAsText(hat) {
      if(hat.DATE_DELETED)
        return 'SİLİNMİŞ'
      
      if(hat.DEVICE_ID == null)
        return 'BOŞTA'
      else
        return 'KULLANIMDA'
    },
    setPage(page) {
      this.activePage = page
      this.getHatlar()
    },
    parseContractStatus(status) {
      if(!status) return ''
      switch(status) {
        case 0: return 'SÖZLEŞME BEKLENİYOR'
        case 1: return 'AKTİF'
        case 2: return 'DONDURULDU'
        default: return 'FESH'
      }
    },
    parseHatOperator(hatGsmNo) {
      if(!hatGsmNo) return ''
      switch(hatGsmNo.substring(0, 2)) {
        case '53':
        case '57':
          return 'TURKCELL'
        case '50':
        case '55':
          return 'TÜRK TELEKOM'
        case '54':
          return 'VODAFONE'
        default: return 'BİLİNMİYOR'
      }
    },
    openModal(modalName) {
      $(`#${modalName}`).modal({
        backdrop: 'static',
        keyboard: false
      })
    },
    dismissBatchImportModal(caller) {
      if(this.batchImportModel.status == 1 && caller == 0) {
        $("#hatBatchImportReportConfirmationModal").modal({
          backdrop: 'static',
          keyboard: false
        });
        return;
      }

      $('#hatBatchImportReportConfirmationModal').modal('hide')
      $('#hatBatchImportModal').modal('hide')
      this.batchImportModel.status = 0
      this.batchImportModel.summary = null
      this.batchImportModel.stagingCount = 0
      this.batchImportModel.results = null
    }
  },
  created() {
    this.$wait.start('hatlar-loading')
  },
  mounted() {
    moment.locale('tr')
    this.getHatlar()
  },
}
</script>

<style lang="css" scoped>

  .tabular-nums {
    -moz-font-feature-settings: "tnum";
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum";
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.025em;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-x {
    overflow: hidden;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .font-semi-bold {
    font-weight: 700;
  }

  .card-body {
    padding: 1rem;
  }

  .card-body p {
    margin-bottom: 4px;
  }

</style>


// WEBPACK FOOTER //
// src/components/YeniHatlarPage.vue